var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_PDF",
    "data-name": "icon PDF",
    transform: "translate(-963 -1256)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1838",
    "data-name": "Rectangle 1838",
    className: "cls-1",
    width: 24,
    height: 24,
    transform: "translate(963 1256)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_PDF_3606966",
    transform: "translate(959 1256.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2348",
    "data-name": "Group 2348",
    transform: "translate(8 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    "data-name": "Path 4170",
    d: "M23.63,13.809V6.373L19.257,2H10.084A1.042,1.042,0,0,0,9.042,3.042V13.809A1.042,1.042,0,0,0,8,14.851v5.557a1.042,1.042,0,0,0,1.042,1.042V21.8a1.042,1.042,0,0,0,1.042,1.042h12.5A1.042,1.042,0,0,0,23.63,21.8v-.347a1.042,1.042,0,0,0,1.042-1.042V14.851A1.042,1.042,0,0,0,23.63,13.809ZM19.462,3.184l2.984,2.984H19.462ZM9.737,3.042a.347.347,0,0,1,.347-.347h8.683V6.863h4.168v6.947H9.737ZM22.935,21.8a.347.347,0,0,1-.347.347h-12.5a.347.347,0,0,1-.347-.347v-.347h13.2Zm1.042-1.389a.347.347,0,0,1-.347.347H9.042a.347.347,0,0,1-.347-.347V14.851a.347.347,0,0,1,.347-.347H23.63a.347.347,0,0,1,.347.347Z",
    transform: "translate(-8 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    "data-name": "Path 4171",
    d: "M17.347,24.695h9.725a.347.347,0,0,0,0-.695H17.347a.347.347,0,0,0,0,.695Z",
    transform: "translate(-13.874 -16.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    "data-name": "Path 4172",
    d: "M27.073,30H17.347a.347.347,0,0,0,0,.695h9.725a.347.347,0,0,0,0-.695Z",
    transform: "translate(-13.874 -20.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    "data-name": "Path 4173",
    d: "M21.817,41.9a1.08,1.08,0,0,0-.42-.219,1.775,1.775,0,0,0-.518-.069H19.723a.347.347,0,0,0-.233.076.233.233,0,0,0-.09.184v3.557a.215.215,0,0,0,.135.2.716.716,0,0,0,.6,0,.215.215,0,0,0,.135-.2V44.218h.552a1.931,1.931,0,0,0,.542-.069,1.094,1.094,0,0,0,.438-.226,1.129,1.129,0,0,0,.292-.4,1.521,1.521,0,0,0,.1-.6v-.028a1.521,1.521,0,0,0-.1-.6A1.018,1.018,0,0,0,21.817,41.9Zm-.472,1.091a.587.587,0,0,1-.135.424.49.49,0,0,1-.368.135h-.57V42.37h.552a.49.49,0,0,1,.368.135.58.58,0,0,1,.153.424Z",
    transform: "translate(-15.44 -27.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    d: "M30.9,41.907a1.066,1.066,0,0,0-.434-.229,1.931,1.931,0,0,0-.542-.069h-.99a.455.455,0,0,0-.278.076.233.233,0,0,0-.1.184v3.564a.233.233,0,0,0,.1.184.455.455,0,0,0,.278.076h.99a2.084,2.084,0,0,0,.542-.069,1.08,1.08,0,0,0,.726-.636,1.535,1.535,0,0,0,.108-.615V42.929a1.528,1.528,0,0,0-.108-.611A1.042,1.042,0,0,0,30.9,41.907Zm-.455,2.466a.58.58,0,0,1-.135.424.5.5,0,0,1-.368.135h-.514V42.369h.5a.5.5,0,0,1,.368.135.58.58,0,0,1,.153.424Z",
    transform: "translate(-21.419 -27.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    d: "M40.37,41.609H38.432a.514.514,0,0,0-.264.066.215.215,0,0,0-.118.2v3.55a.215.215,0,0,0,.135.2.716.716,0,0,0,.6,0,.215.215,0,0,0,.135-.2V43.985h.847a.215.215,0,0,0,.2-.111.438.438,0,0,0,.063-.219.431.431,0,0,0-.069-.24.215.215,0,0,0-.195-.1h-.847V42.37H40.37a.212.212,0,0,0,.195-.115.524.524,0,0,0,.069-.271.552.552,0,0,0-.063-.257A.208.208,0,0,0,40.37,41.609Z",
    transform: "translate(-27.612 -27.851)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.8e3b90c45418516f3a21a9b79307d585.svg";
export { ForwardRef as ReactComponent };